@if (contentState() === 'none') {
  <albert-template-cta-button/>
} @else if (contentState() === 'view' || contentState() === 'edit' || contentState() === 'create') {
  <albert-template-display/>
}
